import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FlexColumn, FlexRow } from '../../../components/atoms/layout/Flex'
import Label from '../../../components/atoms/display/Label'
import Button from '../../../components/atoms/inputs/Button'
import DotPagination from '../../../components/atoms/navigation/DotPagination'
import Terms from '../../../components/atoms/display/Terms'
import Checkbox from '../../../components/atoms/inputs/Checkbox'
import { RegisterActions } from '../../../store/register'
import { RegisterSelectors } from '../../../store/register/selectors'
import usePath from '../../../hooks/usePath'
import Alert from '../../../components/atoms/feedback/Alert'
import useRouter from '../../../hooks/useRouter'

export default function RegisterContracteeTermsPage() {
  const [agree, setAgree] = useState<boolean>(false)
  const { registerContracteeCompleted } = usePath()
  const contractee = useSelector(RegisterSelectors.contractee)
  const dispatch = useDispatch()
  const { registerContracteeEmail } = useRouter()
  const [error, setError] = useState<string | null>(null)

  const handleNext = useCallback(() => {
    if (contractee.email && contractee.password && contractee.uid) {
      const contracteeName = contractee.name ? contractee.name : null
      dispatch(
        RegisterActions.register({
          email: contractee.email,
          password: contractee.password,
          uid: contractee.uid,
          name: contracteeName,
          representativeName: contractee.representativeName,
          isContractee: true,
          getRedirectPath: () => registerContracteeCompleted(),
        })
      )
    } else {
      setError('入力内容がリセットされました')
    }
  }, [contractee, dispatch, registerContracteeCompleted])

  return (
    <FlexColumn align="center" height="calc(100vh - 128px)" justify="space-between" mt={4}>
      <FlexColumn align="center">
        <Label text="アカウント登録" variant="title" />
        <FlexColumn mx={2}>
          <Label text="利用規約を確認" />
          <Terms height={320} />
          <Checkbox label="同意する" checked={agree} onChange={setAgree} />
        </FlexColumn>
        {error && (
          <Alert title={error} severity="error">
            <FlexColumn align="center">
              <FlexColumn space={0}>
                <Label text="お手数をおかけ致しますが、" />
                <Label text="最初のステップに戻り、再度入力をお願い致します" />
              </FlexColumn>
              <Button onClick={registerContracteeEmail}>最初に戻る</Button>
            </FlexColumn>
          </Alert>
        )}
      </FlexColumn>
      <FlexColumn align="center">
        <Button size="lg" disabled={!agree} onClick={handleNext}>
          次へ
        </Button>
        <FlexRow justify="center">
          <DotPagination count={13} current={3} />
        </FlexRow>
      </FlexColumn>
    </FlexColumn>
  )
}
